package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.AvatarDemo

@Page
@Composable
fun AvatarPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/avatar.md", mapOf("title" to listOf("Avatar"), "description" to listOf("An image element with a fallback for representing the user."), "radix" to listOf(), "link" to listOf("https://www.radix-ui.com/docs/primitives/components/avatar"), "api" to listOf("https://www.radix-ui.com/docs/primitives/components/avatar#api-reference")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import radix_ui.components.AvatarProps
import react.FC
import shadcn.ui.components.Avatar
import shadcn.ui.components.AvatarFallback
import shadcn.ui.components.AvatarImage

val AvatarDemo = FC<AvatarProps> {
    Avatar {
        AvatarImage {
            src = "https://github.com/shadcn.png"
            alt = "@shadcn"
        }
        AvatarFallback {
            +"CN"
        }
    }
}"""){ 
 AvatarDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Avatar
import shadcn.ui.components.AvatarFallback
import shadcn.ui.components.AvatarImage
""", lang= "kotlin", highlight= "")
            CodeBlock("""Avatar {
    AvatarImage {
        src = "https://github.com/shadcn.png"
        alt = "@shadcn"
    }
    AvatarFallback {
        +"CN"
    }
}
""", lang= "kotlin", highlight= "")
        }
    }
}
